import { IPage } from "@/types/AppTypes";
import { httpRequest } from "@/utils/HttpRequest";
import { ISalesDetail, ISalesInsert, ISalesSearch, ISalesUpdate, ISalesExamine, ISaleSettlement } from "./salesTypes";
import { ILogistics } from "../shipment/shimentTypes";
import { ISettleParams } from "../public/publicService";


class SalesService {
    async page(searchVo: ISalesSearch, config: object = {}) {
        const apiUrl = "/gtm/sale/listPage";
        return await httpRequest.post<IPage<ISalesDetail>>(apiUrl, searchVo, config);
    }
    async pageBySupplier(searchVo: { "code": string, "shopCode": string }, config: object = {}) {
        const apiUrl = "/gtm/sale/selectBySupplier";
        return await httpRequest.post<ISalesDetail[]>(apiUrl, searchVo, config);
    }
    async one(id: string) {
        const apiUrl = `/gtm/sale/findByIdOrCode/${id}`;
        return await httpRequest.get<ISalesDetail>(apiUrl);
    }
    async insert(insertVo: ISalesInsert) {
        const apiUrl = "/gtm/sale/insert";
        return await httpRequest.post<string>(apiUrl, insertVo);
    }
    async update(updateVo: ISalesUpdate) {
        const apiUrl = "/gtm/sale/update";
        return await httpRequest.post<string>(apiUrl, updateVo);
    }
    // 总监审核
    async examineManager(Vo: ISalesExamine) {
        const apiUrl = "/gtm/sale/examineManager";
        return await httpRequest.post<boolean>(apiUrl, Vo);
    }
    // 财务审核
    async examineReckoner(Vo: ISalesExamine) {
        const apiUrl = "/gtm/sale/examineReckoner";
        return await httpRequest.post<boolean>(apiUrl, Vo);
    }
    // 提交审核
    async submitSales(id: string) {
        const apiUrl = `/gtm/sale/submit/${id}`;
        return await httpRequest.get<boolean>(apiUrl);
    }
    //作废
    async disable(id: string) {
        const apiUrl = `/gtm/sale/disable/${id}`;
        return await httpRequest.get<boolean>(apiUrl);
    }
    //出运
    async whConfirm(vo: { "code": string, "shopCode": string }) {
        const apiUrl = `/gtm/sale/whConfirm`;
        return await httpRequest.post<boolean>(apiUrl, vo);
    }
    //发运
    async transferShipping(vo: { "code": string, "shopCode": string }) {
        const apiUrl = `/gtm/sale/transferShipping`;
        return await httpRequest.post<string>(apiUrl, vo);
    }
    //查询物流进程
    async oneLog(saleCode: string) {
        const apiUrl = `/gtm/sale/logistics/${saleCode}`;
        return await httpRequest.get<ILogistics>(apiUrl);
    }

    // 转采购合同
    async transferPurchase(Vo: { "code": string, "shopCode": string }) {
        const apiUrl = "/gtm/sale/transferPurchase";
        return await httpRequest.post<string>(apiUrl, Vo);
    }

    // 转报关单
    async transferCustoms(Vo: { "code": string, "shopCode": string }) {
        const apiUrl = "/gtm/sale/transferCustoms";
        return await httpRequest.post<string>(apiUrl, Vo);
    }

    //结算
    async settle(settleVo: ISettleParams) {
        const apiUrl = `/gtm/sale/settle`;
        return await httpRequest.post<boolean>(apiUrl, settleVo);
    }

    //导入
    async import(file: { file: File }) {
        const appPageUrl = "/gtm/sale/import";
        return await httpRequest.post<boolean>(appPageUrl, file);
    }
    //导出
    async export(searchVo: ISalesSearch) {
        const appPageUrl = "/gtm/sale/export";
        return await httpRequest.postFile<boolean>(appPageUrl, searchVo, { timeout: 300000 });
    }
    //下载模板
    async downloadTpl() {
        const appPageUrl = "/gtm/sale/downloadTpl";
        return await httpRequest.getFile(appPageUrl);
    }


    //信用证分页查询
    async creditPage(searchVo: any) {
        const apiUrl = `/gtm/exportCredit/search/pg`;
        return await httpRequest.post<IPage<any>>(apiUrl, searchVo);
    }
    //结算
    async receiptSettle(settleVo: ISaleSettlement[]) {
        const apiUrl = `/gtm/receipt/settle`;
        return await httpRequest.post<boolean>(apiUrl, settleVo);
    }
    //结算修改
    async receiptSettleUpdate(settleVo: ISaleSettlement[]) {
        const apiUrl = `/gtm/receipt/update`;
        return await httpRequest.post<boolean>(apiUrl, settleVo);
    }
    //结算分页查询
    async receiptPage(searchVo: any) {
        const apiUrl = `/gtm/receipt/search/pg`;
        return await httpRequest.post<IPage<ISaleSettlement>>(apiUrl, searchVo);
    }
    //外贸收汇完结
    async settleStatu(code: string) {
        const apiUrl = `/gtm/sale/settle/${code}`;
        return await httpRequest.get<boolean>(apiUrl);
    }
    //外贸结汇完结
    async settlementStatu(code: string) {
        const apiUrl = `/gtm/sale/settlement/${code}`;
        return await httpRequest.get<boolean>(apiUrl);
    }
    // 修改审批时间
    offerTime(updateVo: any){
        const apiUrl = `/gtm//audit/update`
        return   httpRequest.post<string>(apiUrl, updateVo);
    }

}

export const salesService = new SalesService();
